import { Box, Button, Dialog, IconButton, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'

import { Icons } from '../../../utils/utilities'

/**
 * Warns the student when their watch progress has repeatedly failed to sync with the backend,
 * so they know to flag it to faculty instead of assuming their watch time is being counted.
 *
 * Render it with `key={video.id}` so a dismissal doesn't carry over to the next video, and so
 * it resets whenever the video player dialog is closed and reopened for the same video.
 */
const VideoProgressSyncFailureDialog = ( { failing = false } ) => {

    const [dismissed, setDismissed] = useState( false )

    const { border, layout } = useTheme()

    if ( !failing || dismissed ) return null

    return (
        <Dialog open maxWidth="xs" slotProps={{ paper: { sx: { maxWidth: "xs" } } }} >
            <Box display="flex" borderBottom={border[1]} padding="10px 20px" gap={layout.sectionsGap} justifyContent="space-between" alignItems="center" >
                <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px" >Your watch progress isn't syncing</Typography>
                <IconButton onClick={() => setDismissed( true )} >
                    {Icons.default.CloseIcon}
                </IconButton>
            </Box>
            <Box padding="20px">
                <Typography variant='body2'>
                    We're unable to save your watch progress right now. Please inform your class faculty so your attendance for this video isn't affected.
                </Typography>
            </Box>
            <Box display="flex" gap="10px" alignItems="center" flexWrap="wrap" padding="20px" paddingTop="0" justifyContent="flex-end">
                <Button size='small' disableElevation onClick={() => setDismissed( true )} color='primary' variant='contained' >Okay</Button>
            </Box>
        </Dialog>
    )
}

export default VideoProgressSyncFailureDialog
